import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WhatsappLiveChatService {
  constructor(private api: ApiService) {}

  getWaConversations(data: any): Observable<any> {
    return this.api.post(environment.getWaConversations, data);
  }

  getWaConversationMessages(data: any): Observable<any> {
    return this.api.post(environment.getWaConversationMessages, data);
  }

  takeoverConversation(data: any): Observable<any> {
    return this.api.post(environment.takeoverConversation, data);
  }

  releaseConversation(data: any): Observable<any> {
    return this.api.post(environment.releaseConversation, data);
  }

  resolveConversation(data: any): Observable<any> {
    return this.api.post(environment.resolveConversation, data);
  }

  sendWaAgentMessage(data: any): Observable<any> {
    return this.api.post(environment.sendWaAgentMessage, data);
  }

  getWaConversationStats(data: any): Observable<any> {
    return this.api.post(environment.getWaConversationStats, data);
  }

  getPendingLiveSessions(data: any): Observable<any> {
    return this.api.post(environment.getPendingLiveSessions, data);
  }
}

